/**
 * Auth flow selection for Hub login.
 * Controlled by `VITE_NATIVE_AUTH_FLOW`: `oauth` (default) or `otp-api`.
 */

export type NativeAuthFlow = 'oauth' | 'otp-api';

/** Reads the build-time auth flow. Unset / unknown values default to `oauth`. */
export function getNativeAuthFlow(
	envValue: string | undefined = import.meta.env.VITE_NATIVE_AUTH_FLOW,
): NativeAuthFlow {
	return envValue === 'otp-api' ? 'otp-api' : 'oauth';
}

/** True when login should use the Keycloak OTP REST API instead of browser/InAppBrowser OAuth. */
export function isOtpApiNativeAuthFlow(envValue?: string): boolean {
	return getNativeAuthFlow(envValue) === 'otp-api';
}
